import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledHeroInteractiveBanner = styled.section`
    height: 100vh;
    position: relative;
    /* opacity is managed by GSAP (gsap.set + gsap.to in Banner.jsx).
       We no longer set opacity:0 here because it hides the LCP image
       from the browser before JS runs, hurting LCP measurement. */


    .main-banner-wrapper-stick {
        width: 100%;
        height: 100%;
    }

    .subDetails {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 145px;
        @media (min-width: 1366px) {
            bottom: 110px;

        }
        @media (max-width: 1366px) {
            bottom: 90px;
        }

        @media (max-width: 767px) {
            position: relative;
            left: 0;
            bottom: unset;
        }
    }

    .swiper-button-prev,
    .swiper-button-next {
        width: ${(p) => p.offset}px;
        height: 100%;
        top: 0;
        margin: 0;
        transition: 0.7s all ease;
        display: block !important;
        z-index: 8;

        &::after {
            display: none;
        }
    }

    .swiper-button-prev {
        left: 0;
        //cursor: url("/images/static/slider-left.svg") 25 25, auto;
    }

    .swiper-button-next {
        //cursor: url("/images/static/slider-right.svg") 25 25, auto;
    }

    .slider-inner_right {
        .setImageOne {
            .image-size {
                height: 130px !important;
                margin-bottom: 20px;
            }

            &:last-child {
                .image-size {
                    margin-bottom: 0;
                }
            }
        }
    }

    .custom-latest-news-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 25px;
        z-index: 9999;
        opacity: 0;

        p {
            color: white;
        }

        @media (max-width: 992px) {
            .col-md-8 {
                max-width: calc(100% - 16.666667%);
                flex: 0 0 calc(100% - 16.666667%);
            }
        }

        @media (max-width: 767px) {
            .col-md-8 {
                max-width: 100%;
                flex: 100%;
            }

            .latest-news {
                margin-bottom: 20px;
            }

            ul {
                li {
                    margin-bottom: 10px;

                    a {
                        display: flex;
                        flex-wrap: wrap;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .tagDataSet {
        margin-top: 10px;

        a {
            color: black;
            margin-right: 10px;
            background: white;
            border-radius: 5px;
            padding: 5px 8px;
        }
    }

    .swiper-button-prev,
    .swiper-button-next,
    .swiper-pagination,
    .mobile {
        display: none;
    }

    .swiper-slide {
        overflow: hidden;
    }

    .swiper-pagination {
        display: none;
    }

    .swiper-button-disabled {
        opacity: 0.5 !important;
    }

    .top-title-wrapper {
        position: relative;
        overflow: hidden;
        min-height: 20px;

        p {
            position: relative;
            margin: 0 0 40px 0 !important;
            transform: translateX(50px);
            transition: 0.4s all ease;
            opacity: 0;
        }
    }

    .title-wrapper-middle {
        position: relative;

        display: flex;
        overflow: hidden !important;
        margin-bottom: 30px;

        h2, h1 {
            position: relative;
            transition: ${theme.transition};
            margin: 0 !important;
            //opacity: 0;
            //transform: translateY(40px);
        }
    }

    .middle-description {
        position: relative;
        overflow: hidden;

        p {
            position: relative;
            margin: 0 !important;
            //transform: translateY(150px);
            transition: 0.7s all ease;
            //transition-delay: 0.5s;
        }
    }

    .swiper-slide-active,
    .swiper-slide-visible {
        .global-image {
            clippath: black;
        }

        //.slide-inner__info p {
        //    position: relative;
        //    margin: 0 !important;
        //    transform: translateY(0);
        //}

        //.title-wrapper-middle {
        //    position: relative;
        //    overflow: visible;
        //
        //    h2 {
        //        position: relative;
        //        opacity: 1;
        //        transition-delay: 0.7s;
        //        transform: none;
        //
        //    }
        //}
        //
        //.middle-description {
        //    p {
        //        position: relative;
        //        margin: 0 !important;
        //        transform: translateY(0);
        //        transition-delay: 0.7s;
        //    }
        //}
        //
        //.top-title-wrapper {
        //    position: relative;
        //
        //    p {
        //        opacity: 1;
        //        transform: translateX(0);
        //    }
        //}

        .slide-inner {
            video {
                position: absolute;
                inset: 0;
                object-fit: cover;
                height: 100%;
                width: 100%;
            }

            .dc-btn {
                z-index: 9;
            }

            img, video {
                height: 100vh !important;
            }

            &__info {
                p {
                    color: #FFF;
                    font-size: 1.25rem; /* 20px / 16 = 1.25rem */
                    font-style: normal;
                    font-weight: 400;
                    line-height: 1.5rem; /* 24px / 16 = 1.5rem (120%) */
                    opacity: 1;
                    width: 70%;
                }
            }
        }
    }

    .custom-navigation-home-slider-wrapper {
        display: flex;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 40px;
        //min-height: 75px;
        text-align: left;
        margin: 0 auto;
        justify-content: space-between;
        gap: 15px;
        flex-direction: row;
        z-index: 99;

        .swiper-wrapper {
            width: 100%;
            height: 3px;
            background-color: rgba(255, 255, 255, 0.20);

            .swiper-slide {
                flex-grow: 1;
                margin: 0 !important;
            }
        }


        .swiper {
            opacity: 0;

            &.swiper-initialized {
                opacity: 1 !important;
            }
        }

        .container {
            margin-top: 0;
            margin-bottom: 0;
        }


        .slide-inner-item {
            width: 100%;
            position: relative;
            background: transparent !important;
            opacity: 1 !important;
            padding: 20px 0 0;
            cursor: pointer;

            @media screen and (min-width: 1536px) {
                padding-right: 15px;
            }

            span {
                font-size: 20px;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.20);
                line-height: 28px;
                opacity: 1 !important;
                transition: 0.7s all ease;
            }

            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 4px;
                background: rgba(255, 255, 255, 1);
                width: 0;
                transition: 0.7s all ease;
                opacity: 0;
                z-index: 999;
            }

            &:hover {
                &:after {
                    width: 100%;
                    opacity: 1;
                }
            }

            &:before {
                content: "";
                background: rgba(255, 255, 255, 0.20) !important;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 4px;
                top: 0;
                z-index: 99;
            }

            &.active {
                &:after {
                    width: 100%;
                    opacity: 1;
                }
            }
        }

        @media (max-width: 767px) {
            bottom: 100px;
        }

        @media (max-width: 445px) {
            bottom: 80px;
        }
    }

    .slide-inner {
        position: relative;
        height: 100vh;

        video {
            position: absolute;
            inset: 0;
            object-fit: cover;
            height: 100%;
            width: 100%;
        }

        .container {
            position: absolute;
            left: 0;
            right: 0;
            /* top: 50%; */
            /* transform: translateY(-50%); */
            z-index: 2;
            display: flex;
            justify-content: center;
            flex-direction: column;
            height: 100%;
        }

        .global-image {
            will-change: clipPath;
            overflow: hidden;
            -webkit-clippath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            clippath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: 0;

            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                z-index: 1;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);

            }

            video {
                position: absolute;
                inset: 0;
                object-fit: cover;
            }
        }

        .global-images {
            will-change: clipPath;
            overflow: hidden;
            -webkit-clippath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            clippath: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: 0;

            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                z-index: 1;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);

            }

            video {
                position: absolute;
                inset: 0;
                object-fit: cover;
            }
        }

        &__info {
            position: relative;
            transition: 0.7s all ease;
            padding-bottom: 5px;

            .container {
                overflow: visible;
            }

            p {
                color: white;
                transition: 0.7s all ease;
                transition-delay: 1.2s;
                width: 70%;
            }

            @media screen and (min-width: 1024px) {
                width: 100%;
            }

            .title {
                transition: 0.7s all ease;
                transition-delay: 1.5s;
                transform: none !important;

                &:after {
                    display: none;
                }
            }


            h2 , h1{
                font-size: 5rem;
                font-style: normal;
                font-weight: 400;
                line-height: 5.1rem; /* 100% */
                letter-spacing: -0.15rem;
                @media (max-width: 1336px) {
                    font-size: 4rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 4.1rem; /* 100% */
                    letter-spacing: -0.15rem;
                }
            }

            .side-wrapper {
                position: relative;
            }
        }
    }

    .navigation {
        position: absolute;
        right: ${(props) => (props.containerGap ? props.containerGap : '90')}px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        z-index: 1;

        ul {
            display: flex;
            flex-direction: column-reverse;

            li {
                cursor: pointer;

                &:first-child {
                    margin-right: 0;
                }

                &:last-child {
                    margin-bottom: 20px;
                }

                svg {
                    path,
                    #Rectangle_5661 {
                        //transition: strokeDasharray 0.3s ease-in-out;
                        transition: 0.7s all ease;
                    }
                }

                &:hover {
                    svg {
                        #Rectangle_5661 {
                            opacity: 1;
                            stroke-dasharray: 140;
                        }

                        path {
                            stroke: #e62e43;
                        }
                    }
                }
            }
        }
    }

    .nav-left {
        position: absolute;
        height: 100%;
        width: 50%;
        left: 0;
        z-index: 9;
        //cursor: url("/images/static/slider-left.svg") 32 32, auto;
    }

    .nav-right {
        position: absolute;
        height: 100%;
        width: 50%;
        right: 0;

        z-index: 9;
        //cursor: url("/images/static/slider-right.svg") 32 32, auto;
    }

    .bottom-navigation-wrapper-home {
        gap: 15px;
        align-items: center;

        .swiper {
            width: 100%;
        }

        .current_total {
            font-weight: 400;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0;
            text-align: right;
            color: #FFFFFF;
        }
    }


    @media screen and (max-width: 992px) {
        .custom-navigation-slider-wrapper {
            bottom: 250px;
        }
    }
    @media (max-width: 992px) and (min-width: 768px) {
        height: 100vh;
        .custom-navigation-slider-wrapper {
            bottom: 60px;

            .swiper-initialized {
                padding-right: 30%;
            }
        }

        .slide-inner {
            height: 100svh;
        }

        .navigation {
            position: absolute;
            right: unset;
            top: unset;
            transform: unset;
            display: inline-block;
            z-index: 1;
            left: ${(props) => (props.containerGap ? props.containerGap : '90')}px;
            bottom: 180px;

            ul {
                flex-direction: row;

                li {
                    &:last-child {
                        margin-bottom: 0;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 767px) {
        height: 100vh;

        .mobile {
            display: block;
        }

        .side-wrapper {
            padding-left: 0 !important;
        }

        .title {
            padding: 0;

            &:before {
                display: none;
            }
        }

        .slide-inner {
            height: 100vh;

            .container {
                top: unset;
                transform: unset;
                /* bottom: 40%; */
            }

            &__info {
                position: relative;
                overflow: hidden;
            }
        }

        .custom-navigation-slider-wrapper {
            padding-left: 15px !important;
            padding-right: 15px !important;
            bottom: 30px;

            .swiper-initialized {
                padding-right: 30%;
            }
        }

        .scrollTo {
            left: 15px;
            right: unset;
            display: inline-block;
            bottom: 20px;
            transform: translateX(0);
        }

        .navigation {
            display: none;
        }
    }

    @media (max-width: 991px) {
        .slide-inner__info .side-wrapper:before {
            display: none;
        }

    }

    @media (max-width: 767px) {
        .slide-inner .container {
            //height: 90%;
            justify-content: flex-end;
            bottom: 145px;
        }

    }
`;